import React from "react";
import { Helmet } from "react-helmet-async";

export default function Seo({ title, description, image, type = "website", jsonLd }) {
  const fullTitle = title ? `${title} | Equine Evolve` : "Equine Evolve | Luxury Equestrian Living. Redefined.";
  const desc =
    description ||
    "Equine Evolve — a luxury equestrian boutique. Handcrafted solid-gold horse bangles, organic soy candles and signature home pieces.";
  const url = typeof window !== "undefined" ? window.location.href : "";
  const ogImage = image || "/images/brand-hero.jpg";

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:url" content={url} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}
